function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.55667 15.882L9.81267 17.272C6.54 16.8507 4 14.0527 4 10.6667C4 6.99067 6.99067 4 10.6667 4C14.008 4 16.7753 6.474 17.2527 9.68533C16.9973 9.30467 16.666 9.012 16.29 8.85667C16.0707 8.766 15.8447 8.71933 15.6167 8.69333C14.83 6.72733 12.9093 5.33333 10.666 5.33333C7.726 5.33333 5.33333 7.726 5.33333 10.6667C5.33333 13.2267 7.14733 15.37 9.55667 15.882ZM20 14.6667V18.6667C20 19.402 19.402 20 18.6667 20H11.6867L10.6667 14.5133V13.3333H14.7893L14.4027 11.1567C14.3647 10.934 14.3833 10.8107 14.398 10.7573C14.5233 10.2973 14.898 10 15.3527 10C15.4947 10 15.638 10.0293 15.7793 10.088C15.9487 10.158 16.1147 10.3327 16.234 10.5673L17.696 13.3333H18.6667C19.402 13.3333 20 13.9313 20 14.6667ZM17.3333 14.6667H12.0407L12.7927 18.6667H17.334L17.3333 14.6667ZM13.3797 9.55026C13.6205 9.31678 13.6566 8.94321 13.465 8.66795C13.2222 8.31921 12.7237 8.2737 12.4218 8.57272L10.0733 10.8987L8.95962 9.80691C8.6966 9.54906 8.27433 9.55333 8.01657 9.81643C7.75888 10.0795 7.76319 10.5016 8.02618 10.7593L9.31 12.0173C9.514 12.2213 9.784 12.3333 10.0727 12.3333C10.3613 12.3333 10.6313 12.2213 10.828 12.0247L13.3797 9.55026Z",
  fill: "#707274"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 14.5H11.5L13 19H17.5L18 14.5Z",
  fill: "#707274",
  stroke: "#707274"
});

function SvgReviewfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewfilled);
export default __webpack_public_path__ + "static/media/review filled.f9094aae.svg";
export { ForwardRef as ReactComponent };